import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FAILURE } from "../../../../constants/AppConstants";

const PinError = () => {
    const {t} = useTranslation(["translation"]);
    const {error: BOCWebDeviceRegistrationErr} = useSelector(state =>state.GetDeviceRegistration);
    const {error: BOCWebDeviceCapabilityErr} = useSelector(state => state.GetBOCWebDeviceCapability);

    const ERR_MSG = {
        '535': t("WEB_CONNECTION.ERROR_MSG.INVALID_OR_EXPIRED_PIN"),
        '537': t("WEB_CONNECTION.ERROR_MSG.BOC_DEVICE_REGISTRATION_API_537_CODE_ERROR_MSG")
    }
    
    const handleWebPINConnectionErr = () => {
        const defaultErrMsg = ERR_MSG['535'];
        const errResp = BOCWebDeviceRegistrationErr || BOCWebDeviceCapabilityErr || null;
        if(errResp?.actionStatus?.toUpperCase() === FAILURE){
            return (errResp?.customCode) 
            ? ERR_MSG[errResp?.customCode] || defaultErrMsg 
            : defaultErrMsg
        }
        return defaultErrMsg;
    }

    return(
        <>
            {
                (BOCWebDeviceRegistrationErr || BOCWebDeviceCapabilityErr)
                ? <div className={`invalid-feedback display-error`}>
                    {handleWebPINConnectionErr()}
                </div>
                : null
            }
        </>
    )
}

export default PinError;